<div class="drawer-container">
  <div class="drawer" [ngClass]="{ expanded: expanded() }">
    <div style="width: 100%">
      <div class="header" [class.header--expanded]="expanded()">
        <div class="header__row">
          <button mat-icon-button (click)="toggleDrawer()" class="header__toggle">
            <mat-icon>{{ expanded() ? 'menu_open' : 'menu_close' }}</mat-icon>
          </button>
          @if (expanded()) {
            <a class="header__logo" routerLink="/">
              <img src="/logo.png" alt="Logo" class="header__logo-img" />
            </a>
          }
        </div>
        <mat-divider></mat-divider>
      </div>
      <mat-nav-list>
        @for (route of routeLinks; track route.link) {
          @let hasChildren = !!route.subRoutes?.length;

          @if (hasChildren && expanded()) {
            <div cdkAccordion>
              <div
                cdkAccordionItem
                #acc="cdkAccordionItem"
                routerLinkActive="active-group"
                [routerLinkActiveOptions]="{ exact: false }"
                #rla="routerLinkActive"
                *crmTgbotHasGroup="route.userGroups"
              >
                @let open = (acc.expanded || rla.isActive) && !collapsed.has(route.link);

                <button
                  mat-list-item
                  class="header"
                  (click)="onHeaderClick(acc, rla, route.link, $event)"
                  [attr.aria-expanded]="open"
                >
                  <mat-icon fontSet="material-icons-outlined">{{ route.icon }}</mat-icon>
                  <span class="label">{{ route.name }}</span>
                  <mat-icon class="expand-icon" [class.rotated]="open">expand_more</mat-icon>
                </button>

                <div class="panel" [class.open]="open">
                  @for (c of route.subRoutes; track c.link) {
                    <a
                      mat-list-item
                      [routerLink]="[c.link]"
                      routerLinkActive="active-item"
                      [routerLinkActiveOptions]="{ exact: false }"
                      *crmTgbotHasGroup="c.userGroups"
                    >
                      <span class="list-item-text">{{ c.name }}</span>
                    </a>
                  }
                </div>
              </div>
            </div>
          } @else if (hasChildren) {
            <crm-tgbot-side-nav-dropdown
              class="route"
              closeOnNavigate
              #dd="crmTgbotSideNavDropdown"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: false }"
              *crmTgbotHasGroup="route.userGroups"
            >
              <a class="rla-probe" [routerLink]="route.link" tabindex="-1" aria-hidden="true"></a>

              <div crmTgbotSideNavDropdownTrigger>
                <a mat-list-item [matTooltip]="!expanded() ? route.name : null">
                  <mat-icon fontSet="material-icons-outlined">{{ route.icon }}</mat-icon>
                </a>
              </div>

              <ng-template crmTgbotSideNavDropdownPanel>
                <div class="dd" [class.open]="dd.open()">
                  @for (c of route.subRoutes; track c.link) {
                    <a
                      class="dd-item"
                      [routerLink]="[c.link]"
                      routerLinkActive="active-item"
                      [routerLinkActiveOptions]="{ exact: false }"
                      (click)="dd.open.set(false)"
                      *crmTgbotHasGroup="c.userGroups"
                    >
                      <span class="label">{{ c.name }}</span>
                    </a>
                  }
                </div>
              </ng-template>
            </crm-tgbot-side-nav-dropdown>
          } @else {
            <div
              class="route single"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: false }"
              *crmTgbotHasGroup="route.userGroups"
            >
              <a mat-list-item [routerLink]="route.link" [matTooltip]="!expanded() ? route.name : null">
                <mat-icon fontSet="material-icons-outlined">{{ route.icon }}</mat-icon>
                @if (expanded()) {
                  <span class="list-item-text">{{ route.name }}</span>
                }
              </a>
            </div>
          }
        }
      </mat-nav-list>
    </div>

    <div class="bottom-info">
      @if (!expanded()) {
        <button mat-icon-button color="primary" aria-label="Log out" matTooltip="Log out" (click)="logout()">
          <mat-icon>logout</mat-icon>
        </button>
      }

      <mat-divider></mat-divider>

      <div class="user-profile" [ngClass]="{ expanded: expanded() }">
        <crm-tgbot-avatar [name]="user() | fullName" [avatarUrl]="user()?.avatar || ''"></crm-tgbot-avatar>

        @if (expanded()) {
          <div class="user-info-wrapper">
            <div class="user-info">
              <h3 class="user-name-expanded">
                {{ user() | fullName }}
              </h3>
              <span class="user-email">{{ user()?.email }}</span>
            </div>
            <button mat-icon-button color="primary" aria-label="Log out" matTooltip="Log out" (click)="logout()">
              <mat-icon>logout</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
